import { Box, Stack } from '@mui/material'
import { tokens } from 'ComponentLibrary'
import { Typography } from 'ComponentLibrary/src/piazza'
import { DeviationValueType } from './types'
import { getDeviationValueAndUnit } from './DeviationValue'

const getIconColor = (deviationPercentage?: number, invertTrendColors?: boolean) => {
    const effectiveDeviationPercentage =
        deviationPercentage === undefined ? undefined : invertTrendColors ? -deviationPercentage : deviationPercentage

    if (effectiveDeviationPercentage === undefined) {
        return tokens.ColorGraphNeutralLight
    }
    if (effectiveDeviationPercentage > 0) {
        return tokens.ColorGraphSequentialFourMedium
    }
    if (effectiveDeviationPercentage < 0) {
        return tokens.ColorGraphSequentialEightMedium
    }
    return tokens.ColorGraphSequentialTwoMedium
}

type DeviationLabelProps = {
    label: string
    deviationChange?: DeviationValueType
    invertTrendColors?: boolean
}

export function DeviationLabel({ label, deviationChange, invertTrendColors }: DeviationLabelProps) {
    const valueAndUnit = getDeviationValueAndUnit(deviationChange, true)
    const dotColor = getIconColor(valueAndUnit?.value, invertTrendColors)
    const shouldShowOutlineDot = valueAndUnit?.value === undefined

    return (
        <Stack direction="row" gap={tokens.SizingSpacing100} alignItems="center">
            <Box
                sx={{
                    width: '8px',
                    height: '8px',
                    boxSizing: 'border-box',
                    borderRadius: '50%',
                    flexShrink: 0,
                    backgroundColor: shouldShowOutlineDot ? 'transparent' : dotColor,
                    border: shouldShowOutlineDot ? `2px solid ${dotColor}` : 'none',
                }}
            />
            <Typography variant="textS" color={tokens.ColorTextBold}>
                {label}
            </Typography>
        </Stack>
    )
}
